import React, { useEffect, useState } from "react";

interface VotingPageProps {
	voter: { firstname: string; lastname: string, hasVoted: boolean};
}

interface IVote {
	subject : string;
	anonynous : boolean;
	result : {
		voter? : string;
		choice : string;
		timeVoted? : Date;
	}[];
	timeVoteStarted : Date;
	timeVoteEnded : Date;
	progress : boolean;
	showingResults : boolean;
	choose : string[];
};

interface responsedIVote {
	success : boolean;
	data : IVote | null
}

const VotingPage: React.FC<VotingPageProps> = ({ voter }) => {
	const [currentVote, setCurrentVote] = useState<responsedIVote | null>(null);
	const [hasVoted, setHasVoted] = useState(voter.hasVoted);
	const [selectedChoice, setSelectedChoice] = useState("");

	// Ici tu devras fetch le vote en cours depuis ton backend
	useEffect(() => {
		const fetchVote = async () => {
		const vote : responsedIVote | null = await fetchCurrentVote();

		if (vote)
			setCurrentVote(vote);
		};
		fetchVote();
	}, []);

	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(() => {
		const loadVote = async () => {
			const vote = await fetchCurrentVote();
			console.log("Polled vote:", vote);
			if (vote && vote.data != null)
				setCurrentVote(vote);
			else {
				const showingVote = await fetchShowingVote();
				console.log("Polled vote2:", showingVote);
				if (showingVote)
					setCurrentVote(showingVote);
				else
					setCurrentVote(null);
			}
		};
		const checkVoter = async () => {
			//this function will check if the voter has already voted in the current vote
			await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/voter`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ firstname: voter.firstname, lastname: voter.lastname }),
			}
			)
			.then((response) => {
				if (!response.ok) {
					throw new Error("Network response was not ok");
				}
				return response.json();
			}
			)
			.then((data) => {
				setHasVoted(data.data.hasVoted);
			})
			.catch((error) => {
				console.error("There was a problem with the fetch operation:", error);
			});
		}

		// Chargement initial
		loadVote();

		// Polling toutes les 5 secondes
		const interval = setInterval(() => {
			loadVote();
			checkVoter();
		}, 5000);

		// Cleanup
		return () => clearInterval(interval);
	}, []);


	const fetchCurrentVote = async (): Promise<responsedIVote | null> => {
		const fetchVote: responsedIVote = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/vote/in-progress`, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
		})
		.then((res) => {
			if (!res.ok) {
				throw new Error("Network response was not ok");
			}
			return res.json();
		}
		)

		return fetchVote;
	};
	const fetchShowingVote = async (): Promise<responsedIVote | null> => {
		const fetchVote: responsedIVote = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/vote/results`, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
		})
		.then((res) => {
			if (!res.ok) {
				throw new Error("Network response was not ok");
			}
			return res.json();
		}
		)

		return fetchVote;
	};

	const handleVote = async () => {
		if (!selectedChoice || !currentVote) return;

		await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/vote/vote`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					firstname: voter.firstname,
					lastname: voter.lastname,
					choice: selectedChoice,
				}),
			}
		)
		.then((response) => {
			if (!response.ok) {
				throw new Error("Network response was not ok");
			}
			return response.json();
		})
		.then((data) => {
			console.log("Vote submitted:", data);
		})
		.catch((error) => {
			console.error("There was a problem with the fetch operation:", error);
		});
		setHasVoted(true);
	};

	if (!currentVote || !currentVote.data) {
		return <div className="message">Aucun vote en cours</div>;
	}

	if (currentVote.data.progress) {
		return hasVoted ? (
		<div>Vous avez déjà voté !</div>
		) : (
		<div className="voting-page">
			<h2>{currentVote.data.subject}</h2>
			
			{
			/* eslint eqeqeq: "off" */
			selectedChoice != "" && (<div>Choix sélectionné : {selectedChoice}</div>
			)}
				<div className="vote-options">
					{currentVote.data.choose.map((choice) => (
						<button key={choice} onClick={() => setSelectedChoice(choice)}>
							{choice}
						</button>
					))}
				</div>
			<div className="vote-submit">
				<button disabled={!selectedChoice} onClick={handleVote}>
					Voter
				</button>
			</div>
		</div>
		);
	}

	if (currentVote.data.showingResults) {
			const choiceCounts = currentVote.data.result.reduce<Record<string, number>>((acc, r) => {
			acc[r.choice] = (acc[r.choice] || 0) + 1;
			return acc;
		}, {});
		return (
		<div className="results-page">
			<h2>Résultats du vote : {currentVote.data.subject}</h2>
			<div className="results-counts">
				<h3>Comptage des choix</h3>
				{currentVote.data.choose.map((choice) => (
					<div className="results-count" key={choice}>
						{choice} : {choiceCounts[choice] ?? 0}
					</div>
				))}
			</div>
			<div className="results-list">
				<h3>Votes détaillés</h3>
				{currentVote.data.result.map((r, idx) => {
					if (currentVote.data && currentVote.data.anonynous) {
						return (
						<div className="results-line" key={idx}>
							{r.choice}
						</div>
						);
					}
					return (
					<div className="results-line" key={idx}>
						{r.voter ? `${r.voter} - ${r.choice}` : r.choice}
					</div>
					);
				})}
			</div>
		</div>
		);
	}

	return <div className="message">Aucun vote en cours</div>;
};

export default VotingPage;
